import React, { useState } from 'react';
import { LoginRequest } from '@marageti/z4-sdk/lib/auth/Token';
import useLoginAuth from '../../use-login-auth';
import PasswordVerificationView from './password-verification-view';

export interface PasswordVerificationProps {
  email: string;
  onChangeEmail: () => void;
}

const PasswordVerification = ({
  email,
  onChangeEmail,
}: PasswordVerificationProps): React.ReactElement => {
  const [passwordError, setPasswordError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login } = useLoginAuth();

  const handleSubmit = async (loginRequest: LoginRequest) => {
    setPasswordError(false);
    setIsSubmitting(true);
    try {
      await login(loginRequest);
    } catch {
      setPasswordError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PasswordVerificationView
      email={email}
      isSubmitting={isSubmitting}
      passwordError={passwordError}
      onSubmit={handleSubmit}
      onClearError={() => setPasswordError(false)}
      onChangeEmail={onChangeEmail}
    />
  );
};

export default PasswordVerification;
